var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import { useCupFamilyOptions } from "hooks/use-cup-family-options";
import { useCupMountingOptions } from "hooks/use-cup-mounting-options";
import { useCupOptions } from "hooks/use-cup-options";
import { useCupPumpOptions } from "hooks/use-cup-pump-options";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
import { useCupTechnologyOptions } from "hooks/use-cup-technology-options";
import { ComponentSelect } from "ui/components/panels/canvas/node-components/component-select/component-select";
import { FamilyAndCupSelect } from "ui/components/panels/canvas/node-components/component-select/family-and-cup-select";
export var useComponentSelect = function (nodes, scrollIntoPosition, selectedSection, onFamilySelected) {
    var dispatch = useAppDispatch();
    var nodeIds = useMemo(function () { return nodes.map(function (_a) {
        var id = _a.id;
        return id;
    }); }, [nodes]);
    var _a = useCupFamilyOptions(), cupFamilyOptions = _a.cupFamilyOptions, cupFamilyDropdownImages = _a.cupFamilyDropdownImages;
    var selectedCups = useAppSelector(selectors.selectSelectedCups(nodeIds));
    var familiesOfSelectedCups = Array.from(new Set(selectedCups.map(function (cup) { return cup === null || cup === void 0 ? void 0 : cup.cupFamily; }).filter(Boolean)));
    var _b = __read(useState(familiesOfSelectedCups.length > 0 ? familiesOfSelectedCups : []), 2), selectedCupFamilies = _b[0], setSelectedCupFamilies = _b[1];
    var _c = useCupOptions(nodes, selectedCupFamilies), cupOptions = _c.cupOptions, selectedCupOptions = _c.selectedCupOptions, selectedCupImage = _c.selectedCupImage;
    var _d = useCupMountingOptions(nodeIds), cupMountingOptions = _d.cupMountingOptions, selectedCupMountingOptions = _d.selectedCupMountingOptions;
    var _e = useCupPumpOptions(nodeIds), pumpOptions = _e.pumpOptions, selectedPumpOptions = _e.selectedPumpOptions;
    var _f = useCupTechnologyOptions(nodeIds), cupTechnologyOptions = _f.cupTechnologyOptions, selectedCupTechnologyOptions = _f.selectedCupTechnologyOptions;
    var onSelectCupFamily = useCallback(function (cupFamily) {
        setSelectedCupFamilies([cupFamily]);
        onFamilySelected === null || onFamilySelected === void 0 ? void 0 : onFamilySelected();
    }, [onFamilySelected]);
    var onSelectCup = useCallback(function (cup) {
        var selectedCupOption = cupOptions.find(function (option) { return option.value === cup; });
        if (selectedCupOption === null || selectedCupOption === void 0 ? void 0 : selectedCupOption.cupFamily) {
            setSelectedCupFamilies([selectedCupOption.cupFamily]);
        }
        dispatch(actions.selectCup({
            nodeIds: nodeIds,
            value: cup,
        }));
    }, [cupOptions, dispatch, nodeIds]);
    var onSelectCupMounting = useCallback(function (cupMounting) {
        dispatch(actions.selectCupMounting({
            nodeIds: nodeIds,
            value: cupMounting,
        }));
    }, [dispatch, nodeIds]);
    var onSelectCupTechnology = useCallback(function (cupTechnology) {
        dispatch(actions.selectCupTechnology({ nodeIds: nodeIds, value: cupTechnology }));
    }, [dispatch, nodeIds]);
    var onSelectPump = useCallback(function (pump) {
        dispatch(actions.selectDecentralPump({
            nodeIds: nodeIds,
            value: pump,
        }));
    }, [dispatch, nodeIds]);
    var component = useMemo(function () {
        switch (selectedSection) {
            case "family":
                return (_jsx(ComponentSelect, { labels: cupFamilyOptions.map(function (option) { return option; }), values: cupFamilyOptions.map(function (option) { return option; }), images: cupFamilyDropdownImages, selectedValues: selectedCupFamilies, onValueChange: onSelectCupFamily, scrollIntoPosition: scrollIntoPosition }, selectedSection));
            case "cup-combined":
                return (_jsx(FamilyAndCupSelect, { cupFamilyOptions: cupFamilyOptions, cupFamilyDropdownImages: cupFamilyDropdownImages, selectedCupFamilies: selectedCupFamilies, onSelectCupFamily: onSelectCupFamily, cupOptions: cupOptions, selectedCupOptions: selectedCupOptions, selectedCupImage: selectedCupImage, onSelectCup: onSelectCup, scrollIntoPosition: scrollIntoPosition }));
            case "cup":
                return (_jsx(ComponentSelect, { labels: cupOptions.map(function (option) { return option.label; }), values: cupOptions.map(function (option) { return option.value; }), images: cupOptions.map(function (option) { return option.image; }), selectedValues: selectedCupOptions.map(function (cup) { return cup.value; }), onValueChange: onSelectCup, scrollIntoPosition: scrollIntoPosition }, selectedSection));
            case "technology":
                return (_jsx(ComponentSelect, { labels: cupTechnologyOptions.map(function (option) { return option.label; }), values: cupTechnologyOptions.map(function (option) { return option.value; }), selectedValues: selectedCupTechnologyOptions.map(function (tech) { return tech.value; }), onValueChange: onSelectCupTechnology, scrollIntoPosition: scrollIntoPosition }, selectedSection));
            case "mounting":
                return (_jsx(ComponentSelect, { labels: cupMountingOptions.map(function (option) { return option.label; }), values: cupMountingOptions.map(function (option) { return option.value; }), selectedValues: selectedCupMountingOptions.map(function (mounting) { return mounting.value; }), onValueChange: onSelectCupMounting, scrollIntoPosition: scrollIntoPosition }, selectedSection));
            case "pump":
                return (_jsx(ComponentSelect, { labels: pumpOptions.map(function (option) { return option.label; }), values: pumpOptions.map(function (option) { return option.value; }), selectedValues: selectedPumpOptions.map(function (pump) { return pump.value; }), onValueChange: onSelectPump, scrollIntoPosition: scrollIntoPosition }, selectedSection));
            default:
                return undefined;
        }
    }, [
        selectedSection,
        cupFamilyOptions,
        cupFamilyDropdownImages,
        selectedCupFamilies,
        onSelectCupFamily,
        scrollIntoPosition,
        cupOptions,
        selectedCupOptions,
        selectedCupImage,
        onSelectCup,
        cupTechnologyOptions,
        selectedCupTechnologyOptions,
        onSelectCupTechnology,
        cupMountingOptions,
        selectedCupMountingOptions,
        onSelectCupMounting,
        pumpOptions,
        selectedPumpOptions,
        onSelectPump,
    ]);
    return {
        component: component,
        selectedCupFamilies: selectedCupFamilies,
        cupFamilyOptions: cupFamilyOptions,
        cupFamilyDropdownImages: cupFamilyDropdownImages,
        cupOptions: cupOptions,
        selectedCupOptions: selectedCupOptions,
        onSelectCupFamily: onSelectCupFamily,
        onSelectCup: onSelectCup,
        selectedCupMountingOptions: selectedCupMountingOptions,
        selectedPumpOptions: selectedPumpOptions,
        selectedCupTechnologyOptions: selectedCupTechnologyOptions,
        cupTechnologyOptions: cupTechnologyOptions,
    };
};
